import $ from 'jquery'

$(document).ready(() => {
  // App page: send phone verification
  $("#send-sms-verification").submit(function (event) {
    if ($('#send-sms-verification #tel').val().length < 10) {
      $("#send-sms-verification #send-sms-verification-error-1").show();
      return false;
    } else {
      $("#send-sms-verification-submit").prop("disabled", true);
    }
  });
  $('#send-sms-verification #tel').on('keyup keypress', function () {
    $("#send-sms-verification .error").hide();
  });
})